<template>
  <div class="tab2">
    <el-button class="btn btn1" style="margin-left: 0" icon="el-icon-circle-plus-outline"  @click="addData">{{ $t("message.button.add") }}</el-button>
    <el-button class="btn btn1" style="margin-left: 10px" icon="el-icon-document-delete" @click="clearSelected">{{ $t("message.button.clearSelected") }}</el-button>

    <el-button class="btn btn3" icon="el-icon-document-checked" @click="Submit" >{{ $t("message.button.save") }}</el-button>
    <el-button class="btn btn8" icon="el-icon-circle-close" @click="reload">{{ $t("message.button.cancel") }}</el-button>

    <div style="padding: 10px 0">
      <vxe-table ref="xTable" keep-source auto-resize :highlightCurrentRow="true" :tree-config="{
          children: 'children',
          hasChild: 'hasChild',
          expandAll: true,
        }" @cell-dblclick='dblClick' :data="tableData" :edit-config="{ trigger: 'dblclick', mode: 'cell', showStatus: true , activeMethod: activeCellMethod,}" :edit-rules="validRules">
        <vxe-table-column field="entryValue" :title="this.$t('message.table.name')" :edit-render="{ name: 'input', attrs: { type: 'text' }, }" tree-node>
          <template #default="{ row }">
            <span>{{ row.entryValue }}</span>
          </template>
        </vxe-table-column>

        <vxe-table-column field="description" :title="this.$t('message.table.des')" :edit-render="{ name: 'input', attrs: { type: 'text' } }"></vxe-table-column>
        <vxe-table-column field="enabled" :title="this.$t('message.table.status')" :edit-render="{
            name: '$select',
            options: [
              {
                label: this.$t('message.table.enabled'),
                value: 1,
              },
              {
                label: this.$t('message.table.disabled'),
                value: 0,
              },
            ],
          }"></vxe-table-column>

      </vxe-table>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import XEUtils from "xe-utils";
export default {
  data() {
    const nameValid = ({ cellValue, row }) => {
      console.log(this.tempErrId);
      console.log(222);
      // if (!cellValue) {
      //   this.$message.error(this.$t("message.error.name"));
      // }
      console.log(cellValue,row.entryValue);
      let n =
        row.parentEntry == null
          ? this.deepCopy(this.tableData)
          : this.deepCopy(
              this.getRow(this.tableData, row.parentEntry)[0].children
            );
      console.log(n);
      let list = n.filter((i) => i.entryId != row.entryId);
      list = list.map((i) => i.entryValue);
      console.log(list, cellValue);
      if (list.includes(cellValue) && list.length ) {
        this.disableSub = true;
        this.disableAdd = true;
        this.errMsg = cellValue + " 该名称被重复使用，请修改";
        this.$message.error(this.errMsg);
        this.tempErrId = row.tempId;
      }
      else if (!cellValue) {
        this.disableSub = true;
        this.disableAdd = true;
        this.errMsg = this.$t("message.error.name");
        this.$message.error(this.errMsg);
        this.tempErrId = row.tempId;
      } 
      else {
        this.disableSub = false;
        this.disableAdd = false;
        this.errMsg = '';
        this.tempErrId = '';
      }
      // this.disableSub = false;
    };

    return {
      tableData: [],
      UpdateData: [],
      initialData: [],

      Pid: 0,
      errorName: "",

      m: [],
      t: [],
      selectRow: "",
      tempOldData: {},
      disableSub: true,
      disableAdd:false,
      tempErrId: "",

      validRules: {
        entryValue: [
          { required: true, message: "errorName" },
          { validator: nameValid },
        ],
      },
    };
  },
  mounted() {
    // this.errorName = this.$t("message.error.name");
  },
  methods: {
    dblClick({ row }) {
      // console.log(row);
      this.tempOldData = this.deepCopy(row);
    },

    cellClickEvent({ row, columns }) {
      console.log(row, columns);
      this.tempOldData = this.deepCopy(row);
    },

    checkForDuplicates(array) {
      let valuesAlreadySeen = [];
      for (let i = 0; i < array.length; i++) {
        let value = array[i];
        if (valuesAlreadySeen.indexOf(value) !== -1) {
          return true;
        }
        valuesAlreadySeen.push(value);
      }
      return false;
    },
    activeCellMethod({row}){
      console.log(row);
      console.log(this.tempErrId,row.tempId,this.tempErrId != row.tempId);
      
      if (!!(this.tempErrId) && this.tempErrId != row.tempId) {
        this.$message.error(this.errMsg);
        return false
      } else {
        return true
      }
    },
    // editName({ row }) {
    //   this.disableSub = false;
    //   let data = this.deepClone(row);
    //   const name = data.entryValue;
    //   console.log(name);
    //   if (!name) {
    //     this.$message.error(this.$t("message.error.name"));
    //     this.disableSub = true;
    //     return;
    //   }
    //   let n =
    //     row.parentEntry == null
    //       ? this.deepCopy(this.tableData)
    //       : this.deepCopy(this.getRow(this.tableData, row.parentEntry)[0].children);
    //   const list = n.map((i) => i.entryValue);
    //   console.log(list,name);
    //   if (this.checkForDuplicates(list)) {
    //     this.$message.error(name + " 该名称被重复使用");
    //     this.disableSub = true;
    //   }
    // },

    getRow(arr, id) {
      // console.log(arr);
      // newArr = newArr || []
      let findRow = (arr, id, newArr) => {
        newArr = newArr || [];
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i];
          if (item.entryId == id) {
            newArr.push(item);
            return newArr;
          } else {
            if (item["children"].length) {
              // console.log(id,newArr,item["children"]);
              findRow(item["children"], id, newArr);
            }
          }
        }
        return newArr;
      };
      return findRow(arr, id);
    },

    reload() {
      // 清除所有状态
      this.disableSub = true;
      this.disableAdd = false;
      this.tempErrId= '';
      this.$refs.xTable.clearAll();
      return this.getMultiInfo();
    },
    clearSelected() {
      // this.selectRow = null
      // this.$refs.xTable.clearRadioRow()
      this.$refs.xTable.clearCurrentRow();
    },
    radioChangeEvent({ row }) {
      console.log(row);

      if (row._XID == this.selectRow) {
        console.log(1111);
        //this.$refs.xTable.clearRadioRow()
        this.$refs.xTable.clearCurrentRow();
        this.selectRow = "";
      } else {
        this.selectRow = row._XID;
      }
    },

    closeSave() {
      this.getMultiInfo();
      setTimeout(() => {
        //console.log(this);
        this.$refs.xTable.setAllTreeExpand();
      }, 800);

      this.m = [];
      this.t = [];
    },

    addData() {
      console.log('tempErrId:'+ this.tempErrId);
      if (Boolean(this.tempErrId)) {
        const msg = this.errMsg || this.$t("message.error.name");
        this.errMsg = msg;
        this.$message.error(msg)
        return false;
      }
      console.log(this.$refs.xTable);
      let arr = this.$refs.xTable.getUpdateRecords();
      if (typeof arr.tempId !== "string") {
        this.t.concat(arr);
      }

      let row = this.$refs.xTable.getCurrentRecord();
      console.log(row);

      if (row != null) {
        if (!row.entryValue) {
          return false;
        }
        let obj = {
          arr: this.tableData,
          value: row.tempId,
          item: {
            entryValue: "",
            description: "",
            parent: row.listId,
            //parentTemp :row.tempId,
            enabled: 1,
            parentEntry: row.entryId,
            children: [],
            tempId: new Date().getTime() + "",
          },
        };
        this.tableData = this.addChildren(obj);
        if (typeof row.tempId != "string") {
          // console.log('05.19--1120');
          this.m.push(row.children[row.children.length - 1]);
          this.t.push(row);
        }
        this.tempErrId = obj.item.tempId;
        // console.log(this.m);
        this.$refs.xTable.setActiveRow(obj.item);
      } else {
        this.$refs.xTable
          .insert({
            children: [],
            entryValue: "",
            description: "",
            enabled: 1,
            listId: this.$store.state.listId,
            tempId: new Date().getTime() + "",
          })
          .then((res) => {
            console.log(res);
            this.$refs.xTable.setActiveRow(res.row);
            this.tableData.push(res.row);
            console.log(this.tableData);
            this.m.push(res.row);
            this.tempErrId = res.row.tempId;
          });
      }

      // this.$refs.xTable.reloadData()
      // console.log(m);
      // console.log(this.tableData);
    },
    delTempId(arr) {
      let newArr = [];
      arr.forEach((ele) => {
        delete ele.tempId;
        delete ele._XID;
        newArr.push(ele);
        if (ele.children.length != 0) {
          ele.children = this.delTempId();
        } else {
          return;
        }
      });
    },

    addChildren({ arr, value, item }) {
      // console.log({ arr, value, item });
      let newArr = [];
      arr.forEach((ele) => {
        if (ele.tempId === value) {
          // console.log(value);
          if (ele.children == undefined) {
            ele.children = [];
          }
          ele.children.push(item);
          newArr.push(ele);
        } else {
          // console.log(ele);
          if (ele.children.length > 0) {
            ele.children = this.addChildren({
              arr: ele.children,
              value,
              item,
            });
            newArr.push(ele);
          } else {
            newArr.push(ele);
          }
        }
      });
      return newArr;
    },

    // checkArr(arr) {
    //   const list = arr.map((i) => i.entryValue);
    //   if (this.isRepeat(list)) {
    //     // this.$message.error(this.$t('message.error.nameRepeat'))  comment this line as 1175
    //     return false;
    //   }
    //   for (const e in arr) {
    //     const i = arr[e];
    //     if (!i.entryValue) {
    //       console.log(i);
    //       this.$message.error(this.$t("message.error.name"));
    //       return false;
    //     }
    //     if (i.children.length) {
    //       this.checkArr(i.children);
    //     } else {
    //       return true;
    //     }
    //   }
    // },

    Submit() {
      if (Boolean(this.tempErrId)) {
        const msg = this.errMsg || this.$t("message.error.name");
        this.errMsg = msg;
        this.$message.error(msg)
        return false;
      }
      let arr = this.$refs.xTable.getUpdateRecords();
      // console.log(arr);
      arr.map((i) => {
        if (typeof i.tempId !== "string") {
          this.t.push(i);
        }
      });
      // console.log("tttt", this.t);
      if (this.Pid == 0) {
        this.t = [];
      }

      this.$refs.xTable.validate(!true).then((res) => {
        if (!res) {
          if (this.m.length !== 0) {
            const insert = {
              baseListId: this.$store.state.listId,
              parentId: this.Pid,
              insertEntry: this.m,
            };
            this.insertData(insert);
          }
          console.log(this.t.length);
          if (this.t.length !== 0) {
            var update = {
              baseListId: this.$store.state.listId,
              updateEntry: this.t,
            };
            //console.log(update);
            this.updateData(update);
          }
        }
      });
    },
    updateData(obj) {
       for (const i in obj.updateEntry) {
        const item = obj.updateEntry[i];
        if (item.hasOwnProperty('_X_ROW_KEY')) {
          delete item['_X_ROW_KEY'];
        }
        if (item.hasOwnProperty('_XID')) {
          delete item['_XID']
        }
      }
      axios
        .post("/pmdm/admin/list/updateMultistageList/", obj)
        .then((res) => {
          if (res.data.code == 200) {
            console.log(res);
            this.$message({
              type: "success",
              message: res.data.message,
            });
            this.reload();
            //this.$refs.xTable.reloadData(this.tableData);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    insertData(obj) {
      console.log(obj);
      for (const i in obj.insertEntry) {
        const item = obj.insertEntry[i];
        if (item.hasOwnProperty('_X_ROW_KEY')) {
          delete item['_X_ROW_KEY'];
        }
      }
     
      axios
        .post("/pmdm/admin/list/saveMultistageList/", obj)
        .then((res) => {
          if (res.data.code == 200) {
            console.log(res);
            this.$message({
              type: "success",
              message: res.data.message,
            });
            this.reload();
            //this.$refs.xTable.reloadData(this.tableData);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    removeCheckbox() {},
    editDisabledEvent() {},
    noEdit({ row }) {},

    getMultiInfo() {
      axios
        .get(
          "/pmdm/admin/list/getMultistageList?listId=" +
            this.$store.state.listId
        )
        .then((res) => {
          // console.log(res);
          if (res.data.code == 200) {
            this.m = [];
            this.t = [];
            this.tableData = res.data.object.listEntities;
            this.tableData = this.iteration(this.tableData);
            // console.log(this.tableData);

            if (this.tableData.length == 0) {
              this.Pid == 0;
            } else {
              this.Pid = this.$store.state.listId;
            }
            //this.$refs.xTable.setAllTreeExpand(true);
          }
        });
    },
  },
  created() {
    this.getMultiInfo();
  },
};
</script>

<style scoped>
.disableSubmit {
  color: #c0c4cc;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
}
.disableSubmit:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
}

.btn {
  display: inline-block;
  padding: 4px;
  padding-right: 10px;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  font-size: 14px;
}
.btn span {
  position: relative;
  padding: 0 2px;
}

.btn img {
  height: 100%;
  width: 100%;
}

.btn1 {
  height: 32px;
  color: #4b92ff;
  border-color: rgba(75, 146, 255, 0.5);
  background: rgba(75, 146, 255, 0.2);
  margin-left: 20px;
}

.btn1:hover {
  color: #fff;
  background: rgba(75, 146, 255, 0.4);
}

.btn2 {
  height: 32px;
  color: #fe6263;
  border-color: rgba(254, 98, 99, 0.5);
  background: rgba(254, 98, 99, 0.2);
}

.btn2:hover {
  color: #fff;
  background: rgba(254, 98, 99, 0.4);
}

.content-title {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  margin-left: 20px;
  height: 57px;
}

.content-title li {
  float: left;
  padding: 18px 12px 12px 12px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 18px;
}

.content-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.content-title .active {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.btn7 {
  height: 32px;
  color: #4b92ff;
  border-color: rgba(75, 146, 255, 0.5);
  background: rgba(75, 146, 255, 0.2);
}

.btn7:hover {
  color: #fff;
  background: rgba(75, 146, 255, 0.4);
}

.btn8 {
  height: 32px;
  color: #fe6263;
  border-color: rgba(254, 98, 99, 0.5);
  background: rgba(254, 98, 99, 0.2);
}

.btn8:hover {
  color: #fff;
  background: rgba(254, 98, 99, 0.4);
}
</style>
